module.exports = __webpack_public_path__ + "static/media/codeDay.6e7c7202.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/codeDay.png
 ** module id = 146
 ** module chunks = 0
 **/